module.exports = __webpack_public_path__ + "media/images/application2/AppUsersFollowings__dl__item__a-95111c6f0bd3c1d19f14167fb2ddfddc.svg";